import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-units',
  templateUrl: './units.component.html',
  styleUrls: ['./units.component.css']
})
export class UnitsComponent implements OnInit {
    public itemsListUnits: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadUnits(): Promise<void> {
        this.itemsListUnits = await this.datatask.Post(601);
    }

    private async init() {
        this.loadUnits();
    }

    ngOnInit() {
        this.init();
    }
}
